module.exports = __webpack_public_path__ + "static/img/ent-detail-60.cb5a9e7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-60.jpg
// module id = RPqz
// module chunks = 52